import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/consultations/transplantSurgery";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	transplantSurgery: {
		id: "ktx.transplantSurgery.title",
		defaultMessage: "Transzplantációs sebészet"
	},
	result: {
		id: "ktx.transplantSurgery.field.result",
		defaultMessage: "Konzílium eredménye alapján"
	},
	comment: {
		id: "ktx.transplantSurgery.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_transplantSurgery",
	value: {
		schemaId: "transplantSurgery",
		title: messages.transplantSurgery,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
